import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { validate, validators } from 'validate-redux-form';
import { Field, reduxForm, formValueSelector, } from 'redux-form';
import { renderField, renderSwitch, renderFieldCheck, SelectField } from '../../../Utils/renderField/renderField';
import CardEmpty from '../../../Utils/Cards/CardEmpty';
import { viewPermissionMap } from './Utils';
import { connect } from 'react-redux';

const vistas = [
    { value: '/', label: 'Parámetros  generales' },
    { value: '/sales/summary', label: 'Ventas' },
    { value: '/finca/summary', label: 'Finca' },
    { value: '/shopping/summary', label: 'Compras' },
    { value: '/planta-solidos/summary', label: 'Plantas - Sólido' },
    { value: '/planta-latex/summary', label: 'Plantas - Látex' },
    { value: '/logistica/summary', label: 'Logística y exportación' },
    { value: '/administrativos/summary', label: 'Administrativos' },
    { value: '/deuda/summary', label: 'Manejo de deuda' },
    { value: '/inversiones/summary', label: 'Inversiones' },
    { value: '/credito-fiscal/summary', label: 'Crédito Fiscal' }
]

const validateInitialView = (values) => {
    const initialView = values.initial_view;
    const errors = {};

    if (initialView) {
        // permitir que se seleccione configuración o summary para la vista inicial
        const requiredPermission = viewPermissionMap[initialView];
        const initialViewConf = initialView.replace('summary', 'configuration');
        const requiredPermissionConf = viewPermissionMap[initialViewConf];
        if ((requiredPermission && !values[requiredPermission]) &&
            (requiredPermissionConf && !values[requiredPermissionConf])) {
            errors.initial_view = 'Active los permisos correspondientes a esta vista.';
        }
    }

    return errors;
};


let RolForm = props => {
    const { handleSubmit, permisos, editando, initialize, initialValues, reset } = props;

    useEffect(() => {
        if (initialValues) {
            const dataItem = initialValues.item;
            if (!dataItem) return;
            if (!dataItem.initial_view) return;
            const newInitialView = dataItem.initial_view.replace('configuration', 'summary');
            initialize({
                ...dataItem,
                initial_view: newInitialView,
            });
        }
    }, [initialize, initialValues]);

    useEffect(() => {
        if (!editando) {
            initialize({});
        }
    }, [editando])

    return (
        <form onSubmit={handleSubmit} className="roles-form">
            <div className="form-group grid-container d-flex align-items-center flex-column col-12">
                <div className="row col-md-4 p-0">
                    <div className="col-12 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="nombre_rol" className="m-0">NOMBRE DEL ROL</label>
                        </div>
                        <div className="col-md-12 form-group">
                            <Field name="rol_name" component={renderField} type="text" className="form-control" />
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 px-2 mt-2">
                            <div>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2" style={{ height: "fit-content", minHeight: "95.41px" }}>
                                        <div className="d-flex flex-column justify-content-start">
                                            <label>INICIAR EN PANTALLA</label>
                                            <Field component={SelectField} className="form-control" name="initial_view" options={vistas} />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '1.112rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>PARÁMETROS GENERALES</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">PARÁMETROS DE SENSIBILIDAD</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="sensitivity_parameters" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '1.112rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>VENTAS</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="sales_summary" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CONFIGURACIÓN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="sales_configuration" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '1.112rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>FINCA</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="farm_summary" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CONFIGURACIÓN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="farm_configuration" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '1.112rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>COMPRAS</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="shopping_summary" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CONFIGURACIÓN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="shopping_configuration" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>

                            <div style={{ marginTop: '1.112rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>PLANTAS</label>
                                        <div className="py-1 mt-1">
                                            <label>SÓLIDOS</label>
                                            <div className="rol-module-field">
                                                <ul>
                                                    <li>
                                                        <label className="gris">RESUMEN</label>
                                                    </li>
                                                </ul>
                                                <Field component={renderFieldCheck} className="form-control" name="solid_summary" />
                                            </div>
                                            <div className="rol-module-field">
                                                <ul>
                                                    <li>
                                                        <label className="gris">CONFIGURACIÓN</label>
                                                    </li>
                                                </ul>
                                                <Field component={renderFieldCheck} className="form-control" name="solid_configuration" />
                                            </div>
                                        </div>
                                        <div className="py-1 mt-1">
                                            <label>LÁTEX</label>
                                            <div className="rol-module-field">
                                                <ul>
                                                    <li>
                                                        <label className="gris">RESUMEN</label>
                                                    </li>
                                                </ul>
                                                <Field component={renderFieldCheck} className="form-control" name="latex_summary" />
                                            </div>
                                            <div className="rol-module-field">
                                                <ul>
                                                    <li>
                                                        <label className="gris">CONFIGURACIÓN</label>
                                                    </li>
                                                </ul>
                                                <Field component={renderFieldCheck} className="form-control" name="latex_configuration" />
                                            </div>
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 px-2 mt-2">
                            <CardEmpty noShadow noPadding>
                                <div className="p-1 mt-1 mx-2">
                                    <label>LOGÍSTICA Y EXPORTACIÓN</label>
                                    <div className="rol-module-field">
                                        <ul>
                                            <li>
                                                <label className="gris">RESUMEN</label>
                                            </li>
                                        </ul>
                                        <Field component={renderFieldCheck} className="form-control" name="logistics_and_export_summary" />
                                    </div>
                                    <div className="rol-module-field">
                                        <ul>
                                            <li>
                                                <label className="gris">CONFIGURACIÓN</label>
                                            </li>
                                        </ul>
                                        <Field component={renderFieldCheck} className="form-control" name="logistics_and_export_configuration" />
                                    </div>
                                </div>
                            </CardEmpty>
                            <div style={{ marginTop: '0.62rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>ADMINISTRATIVOS</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="administrative_summary" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CONFIGURACIÓN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="administrative_configuration" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '0.62rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>MANEJO DE DEUDA</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="debt_management_summary" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CONFIGURACIÓN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="debt_management_configuration" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '0.62rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>INVERSIONES</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="investments_summary" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CONFIGURACIÓN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="investments_configuration" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '0.62rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>CRÉDITO FISCAL</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESUMEN</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="tax_credit_summary" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 px-2 mt-2">
                            <div className="reportes-card" >
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>REPORTES</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">FLUJO DE CAJA</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="cash_flow" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">RESULTADOS</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="results_of_operation" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">COSTO DE COMPRA M.P.A</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="purchase_cost_m_p_a" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">COSTO DE VENTA P.</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="cost_of_sales_p" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                            <div style={{ marginTop: '0.62rem' }}>
                                <CardEmpty noShadow noPadding>
                                    <div className="p-1 mt-1 mx-2">
                                        <label>ADMINISTRACIÓN</label>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">ROLES</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="roles" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">USUARIOS</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="users" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">CLIENTES</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="customers" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">PUERTOS DE SALIDA</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="port_of_departure" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">EMPAQUES</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="packaging" />
                                        </div>
                                        <div className="rol-module-field">
                                            <ul>
                                                <li>
                                                    <label className="gris">TIPOS DE TRANSPORTE</label>
                                                </li>
                                            </ul>
                                            <Field component={renderFieldCheck} className="form-control" name="types_of_transport" />
                                        </div>
                                    </div>
                                </CardEmpty>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center mt-5">
                    <Link className="btn btn-outline-dark m-2" to="/roles">CANCELAR</Link>
                    {editando ?
                        (<button type="submit" className="btn btn-primary my-2 mx-3" onClick={permisos()}>GUARDAR</button>)
                        :
                        (<button type="submit" className="btn btn-primary my-2 mx-3">GUARDAR</button>)
                    }
                </div>
            </div>
        </form>
    )
};

RolForm = reduxForm({
    form: 'RolForm',
    validate: (data) => {
        let errors = validate(data, {
            'rol_name': validators.exists()('Campo requerido.'),
            'initial_view': validators.exists()('Campo requerido.'),
        });
        return { ...errors, ...validateInitialView(data) };
    },
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(RolForm);

const mapStateToProps = (state) => {
    return {
        initialValues: state.roles,
    };
};

export default connect(mapStateToProps)(RolForm)
